/**
 * Text utility functions for dendrogram components
 * Handles text wrapping and formatting for D3 SVG elements
 */

/**
 * Wraps text within a specified width by breaking into multiple tspan elements
 * Centers the text block vertically
 *
 * @param textElement - D3 selection of the text element to wrap
 * @param text - The text content to wrap
 * @param maxWidth - Maximum width in pixels before wrapping
 */
export const wrapText = (textElement: any, text: string, maxWidth: number): void => {
    const words = text.split(/\s+/);
    const lineHeight = 1.1; // ems
    const y = textElement.attr('y') || 0;
    const dy = parseFloat(textElement.attr('dy') || '0');

    textElement.text(''); // Clear existing text

    let line: string[] = [];
    let lineNumber = 0;
    let tspan = textElement.append('tspan')
        .attr('x', textElement.attr('x'))
        .attr('y', y)
        .attr('dy', dy + 'em');

    for (const word of words) {
        line.push(word);
        tspan.text(line.join(' '));

        const node = tspan.node();
        if (node) {
            const computedLength = node.getComputedTextLength();
            if (computedLength > maxWidth) {
                line.pop();
                tspan.text(line.join(' '));
                line = [word];
                tspan = textElement.append('tspan')
                    .attr('x', textElement.attr('x'))
                    .attr('y', y)
                    .attr('dy', ++lineNumber * lineHeight + dy + 'em')
                    .text(word);
            }
        }
    }

    // Center the text block vertically
    const totalLines = lineNumber + 1;
    const offset = -(totalLines - 1) * lineHeight * 0.5;
    textElement.selectAll('tspan').attr('dy', function(this: any, _d: any, i: number): string {
        return (i * lineHeight + offset + dy) + 'em';
    });
};
